
const Config = {
    debugMode: false,
    autoUpdateEnabled: false,
    url: 'https://nebula.spl-token.com:3011/',
    urlDebug: 'https://127.0.0.1:3011/',
    version: '2.875',
    tokenNsaAddress: '4CuBdvKbwy1wo8o9sDs7mUQZTL1weKitpBA6X2D5a1nX',
    tokenNsanAddress: '6J8zQqphXpyM19vKKnAdWn9VWgyEHwuW9q1xzm3wY91W',
    marketIdMsolUsdt: '9Lyhks5bQQxb9EyyX55NtgKQzpM4WK7JCmeaWuQ5MoXD',
    marketIdSolUsdt: '8BnEgHoWFysVcuFFX7QztDmzuH8r5ZFvyP3sYwn1XTh6',
    marketIdNsaUsdt: '9Hfa9aARXtSYKqVxdpvVWZB3gGW4sHffasm8QTptSoZn',
    accountPubkey: '5RtCVaju5kRB9UghFPLPCRuMGpnEG2fvY74s6YxNmdmi',
    solanaCloudUrl: 'https://token-list-api.solana.cloud/v1/mints?chainId=101',
    mainnetSolana: 'https://api.mainnet-beta.solana.com',
    mainnetMoralis: 'https://solana-gateway.moralis.io/token/mainnet',
    apiKeyMoralis: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJub25jZSI6IjQ3MzliMTk1LTNjOGQtNGU4Zi05ZGZkLTBjMWNkMzA4ZWUzMyIsIm9yZ0lkIjoiNDc5MTU3IiwidXNlcklkIjoiNDkyOTU4IiwidHlwZUlkIjoiOWRiMzViMDYtODY4Yy00ZmNkLThkZTgtNzFmZGU1ZTc2YTRjIiwidHlwZSI6IlBST0pFQ1QiLCJpYXQiOjE3NjIwOTgxNTQsImV4cCI6NDkxNzg1ODE1NH0.Dy_-IbqOySP8GtkXmli15lWkd_3fuMwE4GQ8yMURfBw',
    mainnetLeoRPC: 'https://solana.leorpc.com/?api_key=FREE',
    mainnetConstantK_Us: 'https://rpc-indianapolis.constant-k.com/?api-key=',
    mainnetConstantK_Eu: 'https://rpc-frankfurt.constant-k.com/?api-key=',
    mainnetConstantK_WS_Us: 'wss://ws-indianapolis.constant-k.com:1337/ws?api-key=',
    mainnetConstantK_WS_Eu: 'wss://ws-frankfurt.constant-k.com:1337/ws?api-key=',
    apiKeyConstantK: 'n824ktmw-63td-4zk2-l5bm-p8vbdrtl20ce',
    gitbookRiskURL: 'https://nebula-stars-anthill.gitbook.io/white-paper-en/policies/the-risks',
};

export default Config;